<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>The Paw Gym</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)" color="primary">
    <ion-refresher-content pullingText="Pull to refresh" refreshingSpinner="circular" refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <ion-grid *ngIf="!isLoading">
    <ion-row>
      <ion-col sizeXl=" 10" offsetXl="1">
        <ion-segment value="dogs" [(ngModel)]="filter" (ionChange)="filterExercises()">
          <ion-segment-button value="dogs">
            <ion-label>
              Dogs
            </ion-label>
          </ion-segment-button>
          <ion-segment-button value="cats">
            <ion-label>
              Cats
            </ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="ion-text-center ion-padding" *ngIf="!isLoading && exercises.length===0">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-img src="../../../assets/images/MimboLogo.png" class="logo"></ion-img>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-text color="darkmimbo">No exercises available at the moment. We promise you to add some. <br />
    </ion-text>
  </div>
  <ion-grid *ngIf="!isLoading && exercises.length>0">
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-list>
          <div *ngFor="let exercise of exercises">
            <ion-item detail color="lightmimbo" [routerLink]="'/exercise/' + exercise.id" class="list-item">
              <img [src]="exercise.thumbnailImage" class="avatar" />
              <div>
                <h1>
                  {{exercise.name}} <span class="goal">{{exercise.goal}}</span>
                </h1>
              </div>
            </ion-item>
          </div>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-fab-button [routerLink]="['/training-tools']"><ion-icon src="../../assets/images/icons/clicker.svg"
      size="large"></ion-icon></ion-fab-button>
</ion-content>